import { ArrowLeftLine, ArrowRightLine } from "@rsuite/icons";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, matchRoutes } from "react-router-dom";
import {
  Avatar,
  AvatarGroup,
  Container,
  Content,
  Footer,
  Header,
  Loader,
  Nav,
  Navbar,
  SelectPicker,
  Sidebar,
  Sidenav,
} from "rsuite";
import { messageTypeArr, roleTypeArr } from "../../../core/config/AppConstants";
import { HelperServices } from "../../../core/services/HelperServices";
import { UserServices } from "../../../core/services/UserServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import {
  ContentRoutes,
  GlobalRoutes,
  HIDE_COMPANY_DROP_DOWN,
  ContentIdRoutes,
} from "../../../navigation/NavConstant";
import {
  headerCompanyInitialState,
  setCompany,
  setCompanyDropDown,
} from "../../../redux/company";
import { setCountry } from "../../../redux/country";
import { setMenu } from "../../../redux/menu";
import { setUserImage } from "../../../redux/user";
import { isEmptyVal } from "../../../utils/helpers";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import ImageModal from "../../components/Modals/ImageModal/ImageModal";
import RecieveNotification from "../../Modules/Notification/RecieveNotification";
import BottomMenu from "./BottomMenu";
import ContentLayout from "./ContentLayout";
import "./Layout.css";
//import "bootstrap/dist/css/bootstrap.css"; // Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap-grid.css"; // Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap-utilities.css"; // Import Bootstrap CSS
import { ModalWrapper } from "./ModalWrapper";
import { SideMenu } from "./SideMenu";
import TopMenu from "./TopMenu";
import { TopRightMenu } from "./TopRightMenu";
interface ImageModal {
  openModal: () => void;
  removePic: () => void;
  hideDelete: () => void;
}

const headerStyles: any = {
  paddingLeft: 18,
  paddingTop: 8,
  fontSize: 16,
  height: 56,
  background: "#34c3ff",
  color: " #fff",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

const headerStylesShrinked: any = {
  paddingLeft: 5,
  paddingBottom: 5,
  paddingTop: 8,
  fontSize: 16,
  height: 56,
  background: "#00BCD4",
  color: " #fff",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

const contentHeaderStyles: any = {
  background: "#00BCD4",
  color: " #fff",
  whiteSpace: "nowrap",
};

const NavToggle = ({ expand, onChange }: { expand: any; onChange: any }) => {
  return (
    <Navbar appearance="subtle" className="nav-toggle">
      <Navbar.Body>
        <Nav pullRight>
          <Nav.Item
            className="nav-item-left"
            onClick={onChange}
            title="Click to expand Menu"
          >
            {expand ? <ArrowLeftLine /> : <ArrowRightLine />}
          </Nav.Item>
        </Nav>
      </Navbar.Body>
    </Navbar>
  );
};

export function Layout() {
  const { t } = useTranslation();
  const [expand, setExpand] = React.useState(false);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [currentUserName, setCurrentUserName] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [menuOpenClass, setMenuOpenClass] = useState("hamburger-menu");
  const [selectedCompany, setSelectedCompany] = useState(0);
  const [companies, setCompanies] = useState<[]>([]);
  const dispatch = useDispatch();
  const [activePath, setActivePath] = useState<string>(ContentRoutes.DASHBOARD);
  const menu = useSelector((state: any) => state.menu);
  const companyState = useSelector((state: any) => state.company);
  const userState = useSelector((state: any) => state.user);
  const imgModalRef = useRef<ImageModal>(null);
  const comanyLogoModalRef = useRef<ImageModal>(null);
  const [openPictureDelModal, setOpenPictureDelModal] = useState(false);
  const location = useLocation();
  const [initialCompanyData, setInitialCompanyData] = useState<any>([]);

  const toggleMenuOpenClass = () => {
    menuOpenClass == "hamburger-menu"
      ? setMenuOpenClass("hamburger-menu menu-open")
      : setMenuOpenClass("hamburger-menu");
  };

  // const handleSignOut = async () => {
  //   try {
  //     setLoader(true);
  //     const res = await UserServices.userLogout();
  //     if (res && res.status === httpStatusArr.ok) {
  //       setLoader(false);
  //       UtilityServices.clearAllBrowserStorage();
  //       navigate("/login");
  //     }
  //   } catch (error: any) {
  //     setLoader(false);
  //     toaster.push(
  //       <Message type="error">
  //         {error.message ? error.message : "Something Went Wrong !"}
  //       </Message>,
  //       { placement: "topEnd" }
  //     );
  //   }
  // };

  async function fetchCompanies(company: string, isEmpty?: boolean) {
    try {
      if (!company && !isEmpty) {
        return;
      }

      let res = await UserServices.searchCompanies(company);
      setCompanies(res.data.data);
      if (isEmpty && initialCompanyData.length <= 0) {
        setInitialCompanyData(res.data.data);
      }
    } catch (error) {}
  }

  async function fetchCountries() {
    try {
      const countryRes = await HelperServices.getAllValidCountries();
      dispatch(setCountry(countryRes?.data?.data));
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  const useCurrentPath = () => {
    const routeMatch = matchRoutes(ContentIdRoutes, location);
    if (routeMatch !== null && routeMatch[0] !== null) {
      let pt = routeMatch[0].route.path;
      return pt ? pt.replace("/", "") : null;
    }
    return location.pathname.replace("/", "");
  };

  let pathVal = useCurrentPath();
  useEffect(() => {
    setCurrentUserName(UtilityServices.getLoggedInUser("name"));

    if (!UtilityServices.hasLinkPermission(pathVal)) {
      navigate(ContentRoutes.PAGE_401);
    }

    if (UtilityServices.getLoggedInUser("small_image_url")) {
      dispatch(
        setUserImage(UtilityServices.getLoggedInUser("small_image_url"))
      );
    } else {
      dispatch(
        setUserImage(UtilityServices.getLoggedInUser("user_default_image"))
      );
    }
    setCompanyLogo(UtilityServices.getLoggedInUser("company_default_logo"));
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      setCompanyLogo(
        UtilityServices.getLoggedInUser("company")["company_logo_small"]
      );
      dispatch(setCompanyDropDown(false));
    } else {
      fetchCompanies("", true);
    }
    dispatch(setMenu(UtilityServices.getLoggedInUser("menus")));
    fetchCountries();

    let currentRoute = location.pathname.substr(
      location.pathname.indexOf("/") + 1
    );
    setActivePath(`/${currentRoute}`);
    handleCompanyListDisplay(`/${currentRoute}`);
  }, []);

  function handleCompanyListDisplay(eventKey: any) {
    !HIDE_COMPANY_DROP_DOWN.includes(eventKey) &&
    UtilityServices.getLoggedInUser("user_type") === roleTypeArr.backend
      ? dispatch(setCompanyDropDown(true))
      : dispatch(setCompanyDropDown(false));
  }

  function onClickPath(eventKey: any, page_type: string) {
    setMenuOpenClass("hamburger-menu");
    if (page_type === "new") {
      setActivePath(`/${eventKey}`);
      navigate(`/${eventKey}`);
      handleCompanyListDisplay(`/${eventKey}`);
    } else if (page_type === "popup") {
      navigate(`?popup=${eventKey}`);
    }
  }

  const openProfilePicModal = (val: string) => {
    if (!val.includes("user_default.jpg")) {
      imgModalRef.current?.openModal();
    }
  };

  const openComanyLogoModal = (val: string) => {
    comanyLogoModalRef.current?.openModal();
    comanyLogoModalRef.current?.hideDelete();
  };

  const removePic = () => {
    setOpenPictureDelModal(true);
  };

  const deletePic = async () => {
    try {
      setOpenPictureDelModal(false);
      //please use alerts from rsuite itself
      const response: any = await UserServices.deleteUserImage(
        UtilityServices.getLoggedInUser("id")
      );
      dispatch(
        setUserImage(UtilityServices.getLoggedInUser("user_default_image"))
      );
      let userDetails = UtilityServices.getLoggedInUserDetails();
      userDetails.small_image_url = null;
      userDetails.large_image_url = null;
      userDetails.image_url = null;
      UtilityServices.updateLoggedInUserDetails(userDetails);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
    } catch (error: any) {
      //please use alerts from rsuite itself
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  };

  return (
    <div className="show-fake-browser sidebar-page">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          backdrop
          content="Loading..."
          vertical
        />
      )}
      <Container>
        <ModalWrapper />
        <Sidebar
          className={expand ? "sidebar-expand sidebar" : "sidebar"}
          width={expand ? 260 : 56}
          collapsible
        >
          <Sidenav.Header>
            <div style={expand ? headerStyles : headerStylesShrinked}>
              {expand ? (
                <>
                  <span
                    className="brand-logo company-logo"
                    onClick={() => {
                      openComanyLogoModal(companyLogo);
                    }}
                  >
                    <img
                      src={companyLogo}
                      className="img-thumbnail"
                      alt="..."
                    />
                  </span>
                </>
              ) : (
                <span
                  className="company-logo"
                  style={{ width: "15px" }}
                  onClick={() => {
                    openComanyLogoModal(companyLogo);
                  }}
                >
                  <img src={companyLogo} className="img-thumbnail" alt="..." />
                </span>
              )}
            </div>
          </Sidenav.Header>
          <Sidenav
            expanded={expand}
            defaultOpenKeys={["3"]}
            appearance="subtle"
          >
            {menu["left"] && (
              <SideMenu
                menu={menu["left"]}
                activePath={activePath}
                onSelect={onClickPath}
              />
            )}
          </Sidenav>
          <NavToggle expand={expand} onChange={() => setExpand(!expand)} />
        </Sidebar>
        <Container>
          <Header>
            <Navbar
              appearance="subtle"
              style={contentHeaderStyles}
              className="md-flex space-between"
            >
              <a
                href="javascript:;"
                onClick={toggleMenuOpenClass}
                className={menuOpenClass}
              >
                <span></span>
              </a>
              <Navbar.Body className="d-flex mb-menu space-between">
                {menu["top"] && (
                  <TopMenu
                    menu={menu["top"]}
                    activePath={activePath}
                    onSelect={onClickPath}
                  />
                )}
                <Nav className="d-flex">
                  <Nav.Item>
                    {UtilityServices.getLoggedInUser("user_type") ===
                      roleTypeArr.backend &&
                      companyState.showCompanyDropDown && (
                        <SelectPicker
                          data={companies}
                          style={{ width: "150px" }}
                          valueKey="id"
                          id="top-company-dropdown"
                          labelKey="comp_name"
                          onSearch={(query) => fetchCompanies(query, false)}
                          onOpen={() => {
                            setCompanies(initialCompanyData);
                          }}
                          onSelect={(value, item) => {
                            let initData = initialCompanyData;
                            const foundCompany = initData.find(
                              (element: any) => element.id === item.id
                            );
                            if (!foundCompany) {
                              initData.unshift(item);
                              setInitialCompanyData(initData);
                            }
                            dispatch(
                              setCompany({
                                comp_name: item.comp_name,
                                id: item.id,
                              })
                            );
                            setSelectedCompany(item.id);
                            !isEmptyVal(item.small_logo_url)
                              ? setCompanyLogo(item.small_logo_url)
                              : setCompanyLogo(
                                  UtilityServices.getLoggedInUser(
                                    "company_default_logo"
                                  )
                                );
                          }}
                          onClean={(e: any) => {
                            fetchCompanies("", true);
                            dispatch(setCompany(headerCompanyInitialState));
                            setCompanyLogo(
                              UtilityServices.getLoggedInUser(
                                "company_default_logo"
                              )
                            );
                            setSelectedCompany(0);
                          }}
                          value={selectedCompany}
                        />
                      )}
                    {UtilityServices.getLoggedInUser("user_type") ===
                    roleTypeArr.client ? (
                      UtilityServices.getLoggedInUser("company") &&
                      UtilityServices.getLoggedInUser("company").comp_name ? (
                        <label className="cmp-nm"
                          style={{ marginLeft: "10px" }}
                          title={
                            UtilityServices.getLoggedInUser("company").comp_name
                          }
                        >
                          {UtilityServices.getLoggedInUser("company").comp_name}
                        </label>
                      ) : (
                        t("NA")
                      )
                    ) : null}
                  </Nav.Item>
                 
                </Nav>
                <Nav className="set-ttl-icon">
                <Nav.Item>
                    <RecieveNotification />
                  </Nav.Item>
                  <Nav.Item
                    className="nav-item-right"
                    onClick={() => {
                      openProfilePicModal(userState.userImage);
                    }}
                  >
                    <AvatarGroup>
                      <Avatar
                        size="md"
                        circle
                        src={userState.userImage}
                        alt={t("HI") + " " + currentUserName}
                        title={t("HI") + " " + currentUserName}
                        id="avtar-image-top-nav"
                      />
                    </AvatarGroup>
                    <label className="mb-hide" style={{ marginLeft: "10px" }}>
                      {" "}
                      {t("HI")}, {currentUserName}
                    </label>
                  </Nav.Item>
                  {menu["top-right-icon"] && (
                    <TopRightMenu
                      menu={menu["top-right-icon"]}
                      onSelect={onClickPath}
                    ></TopRightMenu>
                  )}
                </Nav>
              </Navbar.Body>
            </Navbar>
          </Header>
          <Content>
            <ContentLayout />
          </Content>
          <Footer>
            <Navbar>
              <Navbar.Body>
                {menu["bottom"] && (
                  <BottomMenu
                    menu={menu["bottom"]}
                    activePath={activePath}
                    onSelect={onClickPath}
                  />
                )}
              </Navbar.Body>
            </Navbar>
          </Footer>
        </Container>
      </Container>

      <ImageModal
        ref={imgModalRef}
        modalTitle={t("PROFILE_PIC")}
        heading={t("PROFILE_PIC")}
        body={
          <img
            src={userState.userImage}
            className="main-profile-pic"
            alt={t("PROFILE_PIC")}
          />
        }
        removePic={removePic}
      />

      <ImageModal
        ref={comanyLogoModalRef}
        modalTitle={t("COMPANY_LOGO")}
        heading={t("COMPANY_LOGO")}
        body={
          <img
            src={companyLogo}
            className="main-profile-pic"
            alt={t("COMPANY_LOGO")}
          />
        }
        removePic={removePic}
      />

      <AlertModal
        open={openPictureDelModal}
        handleClose={(e: any) => {
          if (e) {
            deletePic();
          } else {
            setOpenPictureDelModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("PROFILE_PIC").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
    </div>
  );
}
